import t, { forwardRef as B } from "react";
import { useTheme as E, Typography as d, Stack as y, Badge as I, Avatar as D } from "@mui/material";
import { jsx as $ } from "react/jsx-runtime";
import { createSvgIcon as M } from "@mui/material/utils";
import { g as A } from "./chunk.BurCwd5X.js";
import { I as L } from "./chunk.zlc_6vey.js";
const z = M(/* @__PURE__ */ $("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m5 11H7v-2h10z"
}), "RemoveCircle"), S = {
  online: "Online",
  busy: "Busy",
  "do-not-disturb": "Do Not Disturb",
  offline: "Offline"
}, H = B(
  (e, u) => {
    var g, m, x, h, f;
    const a = E(), l = e.size ? e.size : "48px", i = {
      mediumLabel: /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(d, { variant: "body1" }, (g = e.userDetails) == null ? void 0 : g.name, e.statusIndicator ? ` (${S[e.statusIndicator]})` : ""), /* @__PURE__ */ t.createElement(d, { variant: "body2" }, (m = e.userDetails) == null ? void 0 : m.title)),
      smallLabel: /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(d, { variant: "body1" }, `${e.userDetails && e.userDetails.name ? e.userDetails.name : ""}${e.statusIndicator ? ` (${S[e.statusIndicator]})` : ""}`))
    }, b = /* @__PURE__ */ new Map([
      [
        "72px",
        {
          styles: {
            badgeSize: 24,
            badgeBorder: 2,
            fontStyles: {
              fontSize: "36px",
              lineHeight: "42.19px",
              fontWeight: 500
            }
          },
          label: i.mediumLabel
        }
      ],
      [
        "48px",
        {
          styles: {
            badgeSize: 16,
            badgeBorder: 2,
            fontStyles: {
              fontSize: "24px",
              lineHeight: "28.13px",
              fontWeight: 500
            }
          },
          label: i.mediumLabel
        }
      ],
      [
        "32px",
        {
          styles: {
            badgeSize: 12,
            badgeBorder: 1,
            fontStyles: {
              fontSize: "16px",
              lineHeight: "18.75px",
              fontWeight: 500
            }
          },
          label: i.smallLabel
        }
      ],
      [
        "24px",
        {
          styles: {
            badgeSize: 8,
            badgeBorder: 1,
            fontStyles: {
              fontSize: "12px",
              lineHeight: "14.06px",
              fontWeight: 500
            }
          },
          label: i.smallLabel
        }
      ]
    ]), v = () => {
      switch (l) {
        case "24px":
        case "32px":
          return 1;
        case "48px":
        case "72px":
        default:
          return 2;
      }
    }, w = () => {
      if (!e.statusIndicator)
        return {};
      const r = b.get(l), s = r != null && r.styles.badgeBorder ? r == null ? void 0 : r.styles.badgeBorder : 0, o = r != null && r.styles.badgeSize ? r == null ? void 0 : r.styles.badgeSize : 0;
      switch (e.statusIndicator) {
        case "online":
          return {
            variant: "dot",
            sx: {
              "& .MuiBadge-badge": {
                backgroundColor: a.palette.success.main,
                color: a.palette.success.main,
                border: "1px solid currentColor",
                boxShadow: `0 0 0 ${s + "px"} ${a.palette.background.paper}`,
                width: o + "px",
                height: o + "px",
                borderRadius: "24px"
              }
            }
          };
        case "busy":
          return {
            variant: "dot",
            sx: {
              "& .MuiBadge-badge": {
                backgroundColor: a.palette.error.main,
                color: a.palette.error.main,
                border: "1px solid currentColor",
                boxShadow: `0 0 0 ${s + "px"} ${a.palette.background.paper}`,
                width: o + "px",
                height: o + "px",
                borderRadius: "24px"
              }
            }
          };
        case "do-not-disturb":
          return {
            badgeContent: /* @__PURE__ */ t.createElement(
              z,
              {
                sx: {
                  color: a.palette.error.main,
                  bgcolor: a.palette.common.white,
                  borderRadius: "24px",
                  "&": {
                    fontSize: `${o + s * 2}px`
                  }
                }
              }
            )
          };
        case "offline":
          return {
            variant: "dot",
            sx: {
              "& .MuiBadge-badge": {
                backgroundColor: a.palette.common.white,
                boxSizing: "border-box",
                border: `2px solid ${a.palette.grey[400]}`,
                boxShadow: `0 0 0 ${s + "px"} ${a.palette.background.paper}`,
                width: o + "px",
                height: o + "px",
                borderRadius: "24px"
              }
            }
          };
      }
    }, n = b.get(l), c = (h = (x = e.userDetails) == null ? void 0 : x.name) == null ? void 0 : h.charAt(0);
    return /* @__PURE__ */ t.createElement(
      y,
      {
        id: e.id,
        direction: "row",
        spacing: v(),
        "aria-label": (e.showIconPlaceholder || !c) && !e.imgSrc ? void 0 : e["aria-label"] || "Avatar",
        sx: {
          opacity: e.disabled ? 0.34 : void 0,
          width: "fit-content"
        },
        ref: u,
        onBlur: e.onBlur,
        onFocus: e.onFocus,
        onMouseOver: e.onMouseOver,
        onMouseLeave: e.onMouseLeave,
        ...A(u)
      },
      /* @__PURE__ */ t.createElement(
        I,
        {
          overlap: "circular",
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
          ...w()
        },
        /* @__PURE__ */ t.createElement(
          D,
          {
            sx: {
              bgcolor: a.palette.grey[300],
              color: a.palette.grey[800],
              width: l,
              height: l,
              ...n == null ? void 0 : n.styles.fontStyles
            },
            src: e.imgSrc,
            alt: (f = e.userDetails) != null && f.name ? e.userDetails.name : e.id
          },
          e.showIconPlaceholder || !c ? /* @__PURE__ */ t.createElement(
            L,
            {
              sx: { fontSize: n == null ? void 0 : n.styles.fontStyles.fontSize },
              disabled: e.disabled,
              "aria-label": e["aria-label"] || "Avatar",
              icon: "person_outline"
            }
          ) : c
        )
      ),
      e.userDetails && e.userDetails.display ? /* @__PURE__ */ t.createElement(y, { direction: "column", justifyContent: "center" }, /* @__PURE__ */ t.createElement("span", { "aria-disabled": e.disabled }, n == null ? void 0 : n.label)) : /* @__PURE__ */ t.createElement(t.Fragment, null)
    );
  }
);
export {
  H as A,
  S
};
